import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef, useState } from 'react';

/**
 * Sizes a pane to the rest of the window, so the three-pane conversation view can scroll each
 * pane on its own and keep the composer pinned. It measures where the pane starts instead of
 * trusting the parents to hand down a height, because this region lives inside several layouts
 * (the admin main panel, the tool form tab) and they differ.
 */
export function useFillViewport(t0) {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    bottom: t2,
    min: t3
  } = options;
  const bottom = t2 === undefined ? 16 : t2;
  const min = t3 === undefined ? 560 : t3;
  const ref = useRef(null);
  const [height, setHeight] = useState(null);
  let t4;
  let t5;
  if ($[2] !== bottom || $[3] !== min) {
    t4 = () => {
      const measure = function measure() {
        const element = ref.current;
        if (!element) {
          return;
        }
        const top = element.getBoundingClientRect().top;
        setHeight(Math.max(min, Math.floor(window.innerHeight - top - bottom)));
      };
      measure();
      window.addEventListener("resize", measure);
      const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure);
      observer?.observe(document.body);
      return () => {
        window.removeEventListener("resize", measure);
        observer?.disconnect();
      };
    };
    t5 = [bottom, min];
    $[2] = bottom;
    $[3] = min;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useLayoutEffect(t4, t5);
  let t6;
  if ($[6] !== height) {
    t6 = {
      height,
      ref
    };
    $[6] = height;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}